import React, { FC } from 'react';
import { UserSatisfactionModalProps } from './UserSatisfactionModalProps';
import CustomModal from '../../components/CustomModal';
import SatisfactionRatingIcons from '../../components/SatisfactionRatingIcons';
import { ModalBody } from '@ingka/modal';
import Divider from '../../components/Divider';
import SatisfactionModalInput from '../../components/SatisfactionModalInput';
import Stack from '@mui/material/Stack';
import Button from '@ingka/button';
import { enqueueErrorSnackbar } from '../../store/notifications/actionWrapper';
import { useDispatch } from 'react-redux';

const UserSatisfactionModal: FC<UserSatisfactionModalProps> = ({
  visible,
  submitHandler,
}) => {
  const dispatch = useDispatch();
  const [satisfactionRating, setSatisfactionRating] = React.useState(-1);
  const [feedback, setFeedback] = React.useState('');
  const setSatisfactionRatingHandler = (rating: number) => {
    setSatisfactionRating(rating);
  };
  const feedbackChangedHanlder = (string) => {
    setFeedback(string);
  };
  const rejectSubmit = () => {
    submitHandler({ submitted: false });
  };
  const submitFeedback = () => {
    if (satisfactionRating === -1) return;

    if (
      (satisfactionRating === 1 ||
        satisfactionRating === 2 ||
        satisfactionRating === 3) &&
      !feedback
    ) {
      dispatch(
        enqueueErrorSnackbar(
          'Please provide your feedback to help us improve the tool.',
        ),
      );
      return;
    }

    submitHandler({
      submitted: true,
      rating: satisfactionRating,
      comment: feedback,
    });
  };
  return (
    <>
      <CustomModal
        isVisible={visible}
        onClose={rejectSubmit}
        title={'Please rate your experience'}
        size={'small'}
      >
        <Stack height={'100%'}>
          <ModalBody style={{ flexGrow: 1 }}>
            <SatisfactionRatingIcons
              selectedIcon={satisfactionRating}
              setSelectedIcon={setSatisfactionRatingHandler}
            />
            <Divider />
            <SatisfactionModalInput
              value={feedback}
              onChange={feedbackChangedHanlder}
            />
          </ModalBody>
          <Stack>
            <Divider />
            <Stack width={1} direction={'row'} p={4} spacing={2} mb={1}>
              <Button
                style={{ width: '100%' }}
                data-testid={'close-satisfaction-modal-button'}
                text={'Cancel'}
                type="secondary"
                onClick={rejectSubmit}
              />
              <Button
                style={{ width: '100%' }}
                data-testid={'submit-satisfaction-modal-button'}
                text={'Submit Feedback'}
                type="primary"
                onClick={submitFeedback}
              />
            </Stack>
          </Stack>
        </Stack>
      </CustomModal>
    </>
  );
};

export default UserSatisfactionModal;
